import { TextContainerStyleSheetAll } from "@client/content/Containers/Text/container";
import Link, { type LinkType } from "@client/content/controls/Link/component";
import { getContainerProps, getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type WithIsEditMode } from "@client/types";
import * as React from "react";
import "./style.less";

export type IconBoxesComponentProps = RootContainerProps &
  WithIsEditMode & {
    className: string;
    description: string;
    level: string;
    iconClassName: string;
    iconStyle?: React.CSSProperties;
    title: string;
    textStyle: React.CSSProperties;
    urlType: LinkType;
    url: string;
  };

export default (props: IconBoxesComponentProps) => (
  <TextContainerStyleSheetAll className="wsc_content_icon_box" {...getContainerProps(props)}>
    <div className={props.className}>
      <div className="icon">
        <Link href={props.url} type={props.urlType} preventRedirect={props.isEditMode}>
          <i className={props.iconClassName} style={props.iconStyle} />
        </Link>
      </div>
      <div className="text">
        {!!props.title && (
          <props.TextComponent
            {...getEntityRef(props)}
            className="title"
            toolbar={"basic"}
            prop="title"
            tag={props.level}
            html={props.title}
          />
        )}

        {!!props.description && (
          <props.TextComponent
            {...getEntityRef(props)}
            className="description"
            toolbar={"basic"}
            prop="description"
            html={props.description}
          />
        )}
      </div>
    </div>
  </TextContainerStyleSheetAll>
);
